import {
  CreateLeadForm,
  type CreateLeadFormProps,
} from '@ayocore/erp/crm/client/components/Leads/forms/CreateLeadForm';

/** Стандартная форма с обязательными полями для Grasias. */
export function CreateLeadFormGrasias(props: CreateLeadFormProps) {
  return (
    <CreateLeadForm
      {...props}
      fields={{
        ...props.fields,
        title: { required: true },
        lead_source_id: { required: true },
        manager_id: { required: true },
        sales_area_id: { required: true },
        description: { required: true },
      }}
    />
  );
}
